import React, { forwardRef, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { ChipLabelVariant, FormulaLabel } from '../ChipLabels';
import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IProps {
  children: ReactNode;
  onClear?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  className?: string;
  variant?: ChipLabelVariant;
  isDisabled?: boolean;
}

const StyledCloseIcon = styled(SvgIcon)`
  opacity: 0;
`;

const Container = styled(FormulaLabel)<{
  $hasReducedPaddingRight?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  column-gap: 2px;
  padding: 2px 4px;
  ${({ $hasReducedPaddingRight }) =>
    $hasReducedPaddingRight &&
    css`
      padding-right: 2px;
    `}
  &:hover {
    cursor: pointer;

    ${StyledCloseIcon} {
      opacity: 1;
    }
  }
`;

const Label = styled.span<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    color: ${theme.colors.secondary400};
  `}
`;

export default forwardRef<HTMLDivElement, IProps>(
  ({ children, onClear, className, variant, isDisabled }, ref) => {
    const handleRemove = (
      event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    ) => {
      if (onClear) {
        event.stopPropagation();
        onClear(event);
      }
    };

    return (
      <Container
        ref={ref}
        onMouseDown={handleRemove}
        className={className}
        $variant={variant}
        $hasReducedPaddingRight={!!onClear}
      >
        <Label $isDisabled={isDisabled}>{children}</Label>
        {!!onClear && (
          <StyledCloseIcon
            name="icon-x-bold"
            width={8}
            height={8}
            customFill="currentColor"
          />
        )}
      </Container>
    );
  },
);
